import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "nm_token";

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Fallback de autenticación por token Bearer. Útil en despliegues donde el
// frontend y el API están en dominios distintos y el navegador bloquea las
// cookies de terceros. Si hay token guardado, se adjunta en cada petición.
export function setAuthToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Refresco automático de sesión: si una petición devuelve 401, intentamos
// renovar el access token con el refresh token (cookie) y reintentamos una vez.
let refreshing = null;
api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config;
        const status = error.response?.status;
        const url = original?.url || "";
        const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/register");
        if (status === 401 && original && !original._retry && !isAuthCall) {
            original._retry = true;
            try {
                if (!refreshing) {
                    refreshing = api.post("/auth/refresh").finally(() => {
                        refreshing = null;
                    });
                }
                const { data } = await refreshing;
                if (data?.access_token) setAuthToken(data.access_token);
                return api(original);
            } catch (e) {
                setAuthToken(null);
            }
        }
        return Promise.reject(error);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "Algo ha ido mal. Inténtalo de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function errMsg(e) {
    return formatApiError(e?.response?.data?.detail) || e?.message || "Algo ha ido mal.";
}
